import React from 'react';
import { node } from 'prop-types';
import isNull from 'lodash/isNull';
import Markdown from 'markdown-to-jsx';

const SafeMarkdown = ({ children, ...others }) =>
  isNull(children) ? null : <Markdown {...others}>{children}</Markdown>;

SafeMarkdown.propTypes = { children: node };

SafeMarkdown.defaultProps = { children: null };

export default SafeMarkdown;
